// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2NqOX","imageUploader":"EGiftCard_imageUploader__WQfdG"};